import React from 'react'
import { useTranslation } from 'next-i18next'

import { getNavigationIcon } from '@/constants/navigationAssets'
import { LabelCnt } from '@/components/PriceRange/PriceRange.styled'

import { ServicesTitle } from '../Filters/Services/Services.styled'

import {
  Wrapper,
  SelectedDistance,
  DropdownList,
  DropdownOption,
  Placeholder,
  DropdownIcon
} from './DistanceDropdown.styled'

interface DistanceDropdownUIProps {
  selectedDistance: number | undefined
  isDropdownOpen: boolean
  distanceOptions: number[]
  handleDropdownToggle: () => void
  handleOptionSelect: (distance: number) => void
}

const DistanceDropdownUI: React.FC<DistanceDropdownUIProps> = ({
  selectedDistance,
  isDropdownOpen,
  distanceOptions,
  handleDropdownToggle,
  handleOptionSelect
}) => {
  const { t } = useTranslation('parkings')
  const placeholderText = t('searchNearParking.distance.placeholder')

  return (
    <div>
      <LabelCnt>
        <ServicesTitle>{t('searchNearParking.filters.distance')}</ServicesTitle>
      </LabelCnt>
      <Wrapper>
        <SelectedDistance onClick={handleDropdownToggle}>
          {selectedDistance !== undefined ? (
            <span>+ {selectedDistance} km</span>
          ) : (
            <Placeholder>{placeholderText}</Placeholder>
          )}
          <DropdownIcon
            src={getNavigationIcon('dropdownIcon')}
            alt="dropdown icon"
            isOpen={isDropdownOpen}
          />
        </SelectedDistance>
        {isDropdownOpen && (
          <DropdownList>
            {distanceOptions.map(distance => (
              <DropdownOption
                key={distance}
                onClick={() => handleOptionSelect(distance)}
              >
                + {distance} km
              </DropdownOption>
            ))}
          </DropdownList>
        )}
      </Wrapper>
    </div>
  )
}

export default DistanceDropdownUI
